<div class="shell">
  <aside class="sidebar">
    <div class="sidebar-main">
      <a class="brand" routerLink="/available">
        <span class="brand-mark">
          <mat-icon aria-hidden="true">support_agent</mat-icon>
        </span>
        <span class="brand-label">Operator Panel</span>
      </a>

      <nav class="nav">
        @for (item of navItems; track item.route) {
          @if (!item.superAdminOnly || isSuperAdmin()) {
            <div class="nav-row">
              <a
                class="nav-item"
                [routerLink]="item.route"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: item.exact ?? true }"
              >
                <mat-icon aria-hidden="true">{{ item.icon }}</mat-icon>
                <span>{{ item.label }}</span>
                @if (item.route === '/available' && handoffBadge.count() > 0) {
                  <span class="nav-badge">{{ handoffBadge.count() > 99 ? '99+' : handoffBadge.count() }}</span>
                }
                @if (item.route === '/my-cases' && caseUnread.total() > 0) {
                  <span class="nav-badge">{{ caseUnread.total() > 99 ? '99+' : caseUnread.total() }}</span>
                }
              </a>
              @if (item.addRoute && isSuperAdmin()) {
                <a
                  class="nav-add"
                  [routerLink]="item.addRoute"
                  routerLinkActive="nav-add-active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  title="Add provider"
                >
                  <span class="nav-add-label">Add</span>
                  <mat-icon aria-hidden="true">person_add</mat-icon>
                </a>
              }
            </div>
          }
        }
      </nav>
    </div>

    <div class="sidebar-bottom">
      <div class="sidebar-footer">
        @if (auth.user(); as u) {
          <div class="user">{{ u.email || u.id }}</div>
        }

        <a
          class="nav-item"
          routerLink="/settings"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <mat-icon aria-hidden="true">settings</mat-icon>
          <span>Settings</span>
        </a>

        <button class="nav-item nav-button" type="button" (click)="signOut()">
          <mat-icon aria-hidden="true">logout</mat-icon>
          <span>Log out</span>
        </button>
      </div>
    </div>
  </aside>

  <div class="content">
    <main class="page">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>